import React from "react";
import "./About.css";

// Replace these with your actual image imports
import aboutHeroImg from "../assets/about-hero.png";       // Woman in black top (Center)
import aboutMissionImg from "../assets/about-mission.png"; // Woman in corset (Left)
import aboutDifferentImg from "../assets/about-different.png"; // Woman in white tee (Right)

const About = () => {
  return (
    <div className="about-page">
      
      {/* 1. Main Header */}
      <div className="about-header-container">
        <h1 className="about-main-title">ABOUT QUICKFIT</h1>
      </div>

      {/* 2. Main Grid Layout */}
      <div className="about-content-grid">
        
        {/* --- Left Column: Mission --- */}
        <div className="about-col about-col-left">
          <div className="text-block">
            <h2 className="section-title">OUR MISSION</h2>
            <p className="section-desc">
              We empower everyone to discover and express their unique style with
              confidence and ease. Fashion should be personal, accessible, and
              fun — not overwhelming. QuickFit is here to make that a reality.
            </p>
          </div>
          <div className="image-block mission-img-wrapper">
            <img src={aboutMissionImg} alt="Our Mission" />
          </div>
        </div>

        {/* --- Center Column: Hero --- */}
        <div className="about-col about-col-center">
          <div className="image-block hero-img-wrapper">
            <img src={aboutHeroImg} alt="Personal Style Revolution" />
          </div>
          <div className="text-block">
            <h2 className="center-title">YOUR PERSONAL STYLE REVOLUTION</h2>
          </div>
        </div>

        {/* --- Right Column: Different --- */}
        <div className="about-col about-col-right">
          <div className="image-block diff-img-wrapper">
            <img src={aboutDifferentImg} alt="What makes us different" />
          </div>
          <div className="text-block">
            <h2 className="section-title">WHAT MAKES QUICKFIT DIFFERENT?</h2>
            <p className="section-desc">
              Tired of endless scrolling and guessing what fits? QuickFit
              simplifies your search with AI-powered outfit suggestions tailored
              to your style, size, and wardrobe. We personalize every
              recommendation — so you find what fits and flatters, faster.
            </p>
            <p className="section-desc">
              From curated looks to virtual try-ons (coming soon!), QuickFit
              helps you shop smarter — all in one place.
            </p>
          </div>
        </div>

      </div>

      {/* 3. Newsletter / Coming Soon Section */}
      <div className="about-newsletter-section">
        <div className="newsletter-content">
          <h2 className="newsletter-title">SOMETHING AMAZING IS COMING SOON!</h2>
          <p className="newsletter-subtitle">
            We’re putting the finishing touches on QuickFit. Sign up below to get early access and exclusive launch perks!
          </p>
          
          <form className="newsletter-form" onSubmit={(e) => e.preventDefault()}>
            <input 
              type="email" 
              placeholder="ENTER YOUR EMAIL ADDRESS" 
              className="newsletter-input" 
              required
            />
            <button type="submit" className="newsletter-btn">NOTIFY ME</button>
          </form>
          
          <p className="newsletter-privacy">We respect your privacy. No spam, ever</p>
        </div>
      </div>

    </div>
  );
};

export default About;